import React, { Component } from 'react';
import ChallengeService from '../../services/ChallengeService.js';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import {getAnnouncementsWithChallenge} from 'reducers';
import {updateCompanyAnnouncementsBadgeDate} from 'actions/user.js';
import {getUserProfileCompanyAnnouncementsBadgeDate} from 'reducers/user.js';
import {fetchAnnouncementsPage, clearAnnouncements} from 'actions/announcements.js';
import {completeChallenge} from 'actions/userChallenges.js';
import {initNavbarState} from 'actions/navbar.js';
import {fetchTimeline} from 'actions/timeline.js';
import Utils from '../../utils/Utils.js';
import Announcements from './Announcements.js';
import UserService from 'services/UserService.js';
import DatabaseService from 'services/DatabaseService.js';

class AnnouncementsContainer extends Component {
    constructor(props) {
        super(props);
        this.busy = false; //use this in logic to avoid race conditions
        this.completePending = false;
        this.state = {busy:this.busy, completePending:this.completePending, pinnedAnnouncement:null}; //Variable duplication in state is needed due to state being asynchronous
        this.isNew = this.isNew.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.complete = this.complete.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.setScrollContainer = this.setScrollContainer.bind(this);
        this.scrollContainer = null;
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode: 'main', menuEnable:true, backButtonEnable:false, rewardsEnable:true, title:this.props.t('Announcements')}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        if(this.props.announcements.length==0) {
            this.nextPage();
        }
        this.companyAnnouncementsBadgeDate = this.props.companyAnnouncementsBadgeDate; //Get a copy of the current badge date before it gets updated
        this.props.dispatch(updateCompanyAnnouncementsBadgeDate((new Date()).toISOString()));

        if(this.props.match.params.id) {
            DatabaseService.fetchCompanyAnnouncement(this.props.match.params.id)
                .then((result)=> {
                    this.setState({pinnedAnnouncement:result.announcement});
                })
                .catch((error)=> {
                    window.alert('An error occurred - check logs');
                    console.error(error);
                })
                .then(()=>{
                    this.setState({busy:false});
                });
        }
    }

    componentWillUnmount() {
        this.props.dispatch(clearAnnouncements());
    }

    componentWillReceiveProps(newProps) {
        if(!this.companyAnnouncementsBadgeDate) {
            this.companyAnnouncementsBadgeDate = newProps.companyAnnouncementsBadgeDate;
        }
    }

    onScroll(event) {
        this.loadPageIfEndVisible();
    }

    setScrollContainer(el) {
        this.scrollContainer = el;
    }

    loadPageIfEndVisible() {
        if(this.scrollContainer) {
            var scrollTop =    this.scrollContainer.scrollTop;
            var scrollHeight = this.scrollContainer.scrollHeight;
            var clientHeight = this.scrollContainer.clientHeight;
            var lastPageInView = (scrollTop >= scrollHeight - 1.5*clientHeight);
            if(lastPageInView && this.busy==false && this.props.end==false) {
                this.nextPage();
            }
        }
    }

    nextPage() {
        var date = this.props.nextDate || '';
        var pageSizeLimit=10;
        this.busy = true;
        this.setState({busy:true});
        this.props.dispatch(fetchAnnouncementsPage(date, pageSizeLimit)).then((result)=>{
            if(result.announcements.length) {
                Utils.delay(100).then(()=>{this.loadPageIfEndVisible()});
            }
        })
        .catch((error)=> {
            console.error('ERROR:');
            console.error(error);
        })
        .then(()=>{
            this.busy = false;
            this.setState({busy:false});
        });

    }

	isNew(item) {
        if(!this.companyAnnouncementsBadgeDate) {
            return false;
        }
		return ((new Date(this.companyAnnouncementsBadgeDate)).getTime() < (new Date(item.sentAt)).getTime())
	}

	isExpired(item) {
		return ((new Date()).getTime() > (new Date(item.expiresAt)).getTime())
	}
    
    complete(item) {
        var challenge = item.challenge;
        var challengeId = challenge.id;
        var companyAnnouncementId = item.id;
        if(!this.completePending) {
            this.completePending = true;
            this.setState({completePending:this.completePending});
            this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:true});
            this.props.completeChallenge(challengeId, {}, {companyAnnouncementId:companyAnnouncementId})
                .then((result)=>{//always
                    this.props.refreshDependencies().catch((error)=>console.error('error refreshing data', error));
                })
                .catch((error)=>{
                    console.error(error);
                    window.alert("Error: " + error);
                })
                .then(()=>{//always
                    this.completePending = false;
                    this.setState({completePending:this.completePending});
                    this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:false});
                });
        }


    }

    include(item) {
        return (item.type == 1 || item.type == 2);
    }

    getIcon(item) {
        switch(item.type) {
            case 1:  return 'icon-alarm';
            case 2:  return 'icon-challenges';
            default: return 'help';
        }        
    }

    render() {
        return (
            <Announcements  announcements={this.props.announcements.filter(this.include)}
                            pinnedAnnouncement={this.state.pinnedAnnouncement}
                            isNew={this.isNew}
                            isExpired={this.isExpired}
                            complete={this.complete} 
                            setScrollContainer={this.setScrollContainer}
                            busy={this.state.busy}
                            getIcon={this.getIcon}
                            onScroll={this.onScroll}/>
        );
    }

}

const mapDispatchToProps = (dispatch) => {
    return {
        completeChallenge: (challengeId, userChallenge, params) => dispatch(completeChallenge(challengeId, userChallenge, params)),
        refreshDependencies: () => Promise.all([dispatch(fetchTimeline())]),
        dispatch: dispatch
    };
};

const mapStateToProps = (state, ownProps) => {
    return {announcements:getAnnouncementsWithChallenge(state),
            nextDate:state.announcements.nextDate,
            end:state.announcements.end,
            companyAnnouncementsBadgeDate:getUserProfileCompanyAnnouncementsBadgeDate(state.user) 
           };
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('announcement')(AnnouncementsContainer));;



// WEBPACK FOOTER //
// ./src/modules/newsfeed/AnnouncementsContainer.js